<div *ngIf="confirm$ | async as confirm" class="tab-sync-backdrop" [class.rtl]="isRtl" [attr.dir]="isRtl ? 'rtl' : 'ltr'">
  <div class="tab-sync-dialog" role="alertdialog" aria-modal="true" aria-labelledby="tab-sync-title">
    <h5 id="tab-sync-title">{{ 'tab-sync.' + confirm.kind + '.title' | translate }}</h5>
    <p>{{ 'tab-sync.' + confirm.kind + '.message' | translate }}</p>
    <div class="tab-sync-actions">
      <button type="button" class="tab-sync-cancel" (click)="confirm.resolve(false)">
        {{ 'tab-sync.cancel' | translate }}
      </button>
      <button type="button" class="tab-sync-confirm" (click)="confirm.resolve(true)">
        {{ 'tab-sync.' + confirm.kind + '.confirm' | translate }}
      </button>
    </div>
  </div>
</div>
